const SHARED_PARTES_FILTERS_SESSION_KEY = "planaett:partes:shared-filters";

const SHARED_ADVANCED_FILTER_KEYS = new Set([
	"campanas",
	"empresas",
	"delegaciones",
	"cabos",
	"validado",
	"revisado",
]);

const safeReadSessionJson = (key) => {
	try {
		const rawValue = window.sessionStorage.getItem(key);
		if (!rawValue) {
			return null;
		}

		const parsedValue = JSON.parse(rawValue);
		return parsedValue && typeof parsedValue === "object" ? parsedValue : null;
	} catch (error) {
		return null;
	}
};

const hasOwn = (value, key) =>
	Boolean(value) && Object.prototype.hasOwnProperty.call(value, key);

const resolveRestoreAdvancedFilters = (routeState, sharedState, pageState) => {
	if (hasOwn(routeState, "advancedFilters")) {
		return routeState.advancedFilters;
	}

	if (hasOwn(sharedState, "advancedFilters")) {
		return sharedState.advancedFilters;
	}

	if (hasOwn(pageState, "advancedFilters")) {
		return pageState.advancedFilters;
	}

	return undefined;
};

export const normalizeSharedAdvancedFilters = (filters = []) =>
	(Array.isArray(filters) ? filters : [])
		.filter(
			(item) =>
				typeof item?.key === "string" &&
				item.key.trim() !== "" &&
				SHARED_ADVANCED_FILTER_KEYS.has(item.key)
		)
		.map((item) => ({
			key: item.key,
			seleccionado: Array.isArray(item?.seleccionado)
				? item.seleccionado.map((value) => String(value))
				: [],
		}));

export const readSharedPartesFiltersState = () =>
	safeReadSessionJson(SHARED_PARTES_FILTERS_SESSION_KEY) || {};

export const buildSharedPartesRestoreState = ({
	routeState = null,
	sharedState = null,
	pageState = null,
} = {}) => ({
	...(pageState || {}),
	...(sharedState || {}),
	...(routeState || {}),
	advancedFilters: resolveRestoreAdvancedFilters(routeState, sharedState, pageState),
	filtroAplicado: {
		...(pageState?.filtroAplicado || {}),
		...(sharedState?.filtroAplicado || {}),
		...(routeState?.filtroAplicado || {}),
	},
});

export const updateSharedPartesFiltersState = (partialState = {}) => {
	try {
		const currentState = readSharedPartesFiltersState();
		const nextState = {
			...currentState,
			...partialState,
		};

		if (Object.prototype.hasOwnProperty.call(partialState, "advancedFilters")) {
			nextState.advancedFilters = normalizeSharedAdvancedFilters(partialState.advancedFilters);
		}

		window.sessionStorage.setItem(
			SHARED_PARTES_FILTERS_SESSION_KEY,
			JSON.stringify(nextState)
		);
	} catch (error) {
		// Ignore shared session persistence failures in the UI.
	}
};

export const mergeSharedAdvancedFilters = (
	filters = [],
	sharedFilters = readSharedPartesFiltersState().advancedFilters
) => {
	const normalizedFilters = (Array.isArray(filters) ? filters : []).map((item) => ({
		...item,
		key: typeof item?.key === "string" ? item.key : "",
		seleccionado: Array.isArray(item?.seleccionado)
			? item.seleccionado.map((value) => String(value))
			: [],
	}));

	const normalizedSharedFilters = normalizeSharedAdvancedFilters(sharedFilters);
	if (normalizedSharedFilters.length === 0) {
		return normalizedFilters;
	}

	const sharedMap = new Map(
		normalizedSharedFilters.map((item) => [item.key, item.seleccionado])
	);

	return normalizedFilters.map((item) =>
		sharedMap.has(item.key)
			? {
					...item,
					seleccionado: sharedMap.get(item.key) || [],
			  }
			: item
	);
};
